import "./CssFiles/loading.css";

function Loading() {
    return (
    <div className="BODY">
    <div className="loading">
      <div className="loading-bar"></div>
      <div className="loading-text">Loading...</div>
    </div>
    </div>
    );
}

export default Loading;